import React from 'react';
import { ThemeToggle } from './ThemeToggle';
import {useTheme} from "../ThemeContext";
import {NavLink} from "react-router-dom";

export function NavBar() {

    const { theme } = useTheme();
    const navLinkClass = ({ isActive }: { isActive: boolean }) => `nav-link${isActive ? " active" : ""}`;

    return (
        <nav id="hanz-navbar" className={`navbar navbar-${theme} navbar-expand-md sticky-top py-3 bg-${theme} shadow-sm`}>
            <div className="container"><NavLink className="navbar-brand d-flex align-items-center" to="/">
                <span><span>
                {/*<img id="hanz-navbar-img" className="rounded-circle" src={logo}/>*/}
                </span>
                Hansika Weerasena
            </span>
            </NavLink>
                <button type="button" className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navcol-2"
                        aria-controls="navcol-2" aria-expanded="false" aria-label="Toggle navigation"><span
                    className="visually-hidden">Toggle navigation</span><span className="navbar-toggler-icon"></span>
                </button>
                <div id="navcol-2" className="collapse navbar-collapse">
                    <ul className="navbar-nav ms-auto">
                        <li className="nav-item"><NavLink className={navLinkClass} to="/" end>Home</NavLink></li>
                        <li className="nav-item"><NavLink className={navLinkClass} to="/research">Research</NavLink></li>
                        <li className="nav-item"><NavLink className={navLinkClass} to="/publications">Publications</NavLink></li>
                        <li className="nav-item"><NavLink className={navLinkClass} to="/news">News</NavLink></li>
                        {/*<li className="nav-item"><NavLink className={navLinkClass} to="/about">About</NavLink></li>*/}
                        <li className="nav-item"><NavLink className={navLinkClass} to="/blog">Blog</NavLink></li>
                        <li className="nav-item d-flex align-items-center">
                            <ThemeToggle/>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
}
